import { create } from 'zustand';

interface ContactMessagerStore {
	isOpen: boolean;
	isMinimized: boolean;
	initialSubject: string;
	backdoorAuthOpen: boolean;
	open: (subject?: string) => void;
	minimize: () => void;
	restore: () => void;
	close: () => void;
	openBackdoorAuth: () => void;
	setBackdoorAuthOpen: (open: boolean) => void;
}

export const useContactMessager = create<ContactMessagerStore>((set) => ({
	isOpen: false,
	isMinimized: false,
	initialSubject: '',
	backdoorAuthOpen: false,
	open: (subject = '') =>
		set({ isOpen: true, isMinimized: false, initialSubject: subject }),
	minimize: () => set({ isMinimized: true }),
	restore: () => set({ isMinimized: false }),
	close: () => set({ isOpen: false, isMinimized: false }),
	openBackdoorAuth: () =>
		set({ isOpen: false, isMinimized: false, backdoorAuthOpen: true }),
	setBackdoorAuthOpen: (open) => set({ backdoorAuthOpen: open }),
}));
